import React from 'react'
import { Route , useLocation} from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/footer';
import { ToastContainer } from 'react-toastify';


const MyRoute = (props) => {
    const location = useLocation();
    return (
        <>  {props.mode ?
                <Header type={props.mode} /> : <Header />
            }
            <ToastContainer  position='top-right'/>
            <Route {...props} />
          
            {location.pathname !== '/messages' && (props.mode ? <Footer type={props.mode} /> : <Footer />)}
        </>
    )

}

export default MyRoute;